var map = {
	"./Bee_with_hyphae_06.jpg": 8885,
	"./Fungi_pollen.jpg": 7202,
	"./Fungi_pollen_002.jpg": 7108,
	"./Fungi_spores_002.jpg": 2302,
	"./Fungi_spores_003.jpg": 278,
	"./Fungi_spores_005.jpg": 8663,
	"./Fungi_spores_006.jpg": 669,
	"./Pollen_Fungi_04.jpg": 2657
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 997;